import CloseButtonModal from './close-button-modal'

interface Props {
    close: () => void;
    title: string;
    subtitle: string;
}

export default function HeaderModal({ close, title, subtitle }: Props) {
    return (
        <div className="flex shrink-0 items-center justify-between border-b border-white/10 bg-[#186cb2] px-4 py-3 md:px-5 md:py-4 lg:px-6">
            <div className="min-w-0">
                <p className="truncate text-sm font-semibold leading-tight text-white">
                    {title}
                </p>
                <p className="mt-1 truncate text-[11px] leading-tight text-white/90 md:text-xs">
                    {subtitle}
                </p>
            </div>
            <div className="ml-3 flex shrink-0 items-center justify-end">
                <CloseButtonModal handleClose={close} />
            </div>
        </div>
    )
}
